export const GATSBY_API_URL = process.env.GATSBY_API_URL;
export const PAGE_SIZE = 32;
export const DOTS = "...";
